import React from 'react';
import PropTypes from 'prop-types';
import { FDSecondaryActionButton, FDStack } from '@facet-wealth/design';

export const ReturnToCurrentButton = ({ link, query, onSubmit }) => {
  return (
    <FDStack justifyContent={'flex-end'}>
      <FDSecondaryActionButton
        size={'sm'}
        icon={'chevronLeft'}
        label={query.attr('prompt')}
        onClick={() => onSubmit(link)}
      />
    </FDStack>
  );
};

ReturnToCurrentButton.defaultProps = {
};

ReturnToCurrentButton.propTypes = {
  link: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  onSubmit: PropTypes.object.isRequired,
};
